import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { Announcement } from '../models/announcement';

@Injectable({ providedIn: 'root' })
export class AnnouncementsService {
  private readonly STORAGE_KEY = 'cartoaf.dismissed_announcements';
  cfg: string = "";

  constructor(
    private http: HttpClient,
    private envService: EnvironmentService
  ) {
    this.cfg = this.envService.environment.restServer.split('/').reverse()[0];
  }

  base(path: string) {
      var base_path = this.envService.environment.apiAnnouncements;
      if (path) {
          base_path += path;
      }

      return base_path;
  }

  getAnnouncements(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>(this.base('/announcements'), {params: {config: this.cfg}}).pipe(
      map(response => response['data']),
      map(announcements => {
        this.cleanupDismissedList(announcements);
        return announcements;
      }),
      catchError(() => of([]))
    );
  }

  sortAnnouncements(list: Announcement[]): Announcement[] {
    list.sort((a, b) => (b.priority ?? 0) - (a.priority ?? 0));
    return list;
  }

  fingerprint(a: Announcement): string {
    return a.id || `${a.title}|${a.startDate || ''}|${a.endDate || ''}`;
  }

  getDismissedList(): string[] {
    try {
      const stored = localStorage.getItem(this.STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  markDismissed(a: Announcement): void {
    try {
      const dismissed = this.getDismissedList();
      const fp = this.fingerprint(a);
      if (!dismissed.includes(fp)) {
        dismissed.push(fp);
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(dismissed));
      }
    } catch {}
  }

  shouldShow(a: Announcement): boolean {
    const dismissed = this.getDismissedList();
    return !dismissed.includes(this.fingerprint(a));
  }

  private cleanupDismissedList(announcements: Announcement[]): void {
    try {
      const dismissed = this.getDismissedList();
      const validFingerprints = announcements.map(a => this.fingerprint(a));
      const cleaned = dismissed.filter(fp => validFingerprints.includes(fp));
      
      if (cleaned.length !== dismissed.length) {
        localStorage.setItem(this.STORAGE_KEY, JSON.stringify(cleaned));
      }
    } catch {}
  }
}
